<div
  class="flex flex-col gap-[24px] justify-start items-center"
  *ngrxLet="gatewayCommissioningStore.emailAddress$ as email"
>
  <div class="img-wrapper">
    <img src="assets/img/thumbs-up-installer.png" />
  </div>
  <div class="commissioning-subtitle">
    {{ '+GATEWAY_COMMISSIONING_REDESIGN.COMMISSIONING_SUCCESS_TITLE' | translate }}
  </div>

  <div
    *ngIf="activeStep === step.TRANSFER_OMA_INSTALLATION_SUCCESS"
    class="commissioning-description"
  >
    {{ '+GATEWAY_COMMISSIONING_REDESIGN.COMMISSIONING_SUCCESS_OMA_DESCRIPTION' | translate }}
  </div>

  <div
    class="commissioning-description"
    *ngIf="
      activeStep === step.TRANSFER_INSTALLATION_SUCCESS ||
      (activeStep === step.TRANSFER_COMMERCIAL_INSTALLATION_SUCCESS && email)
    "
  >
    {{ '+GATEWAY_COMMISSIONING_REDESIGN.COMMISSIONING_SUCCESS_EMAIL_DESCRIPTION' | translate }}
    <span class="email">{{ email }}</span>
  </div>

  <div class="full-width flex flex-row xs:flex-col xs:gap-[16px] justify-center items-center">
    <button
      class="next-step-btn"
      mat-raised-button
      gtm="onPreviousStep"
      gtmCategory="gatewayCommissioningTransferSuccess"
      data-at-back-to-overview-btn
      color="primary"
      (click)="goToInstallationList()"
    >
      {{ '+GATEWAY_COMMISSIONING_REDESIGN.BTN_GO_TO_INSTALLATION_LIST' | translate }}
      <mat-icon>arrow_forward</mat-icon>
    </button>

    <button
      mat-stroked-button
      data-at-no-btn
      gtm="onSet"
      gtmAction="New setup"
      gtmCategory="gatewayCommissioningTransferSuccess"
      (click)="newSetup()"
    >
      {{ '+GATEWAY_COMMISSIONING_REDESIGN.BTN_NEW_SETUP' | translate }}
    </button>
  </div>
</div>
